export enum FileUploadWorkflowNode {
  PatientFiles = 1,
  UploadYourDesigns,
}
